import { useQuery } from '@tanstack/react-query';
import {
  WalletInvestmentCategory,
  InvestorProfile,
} from '../../interface/walet';
import { api } from '@/libs/axios/apiClient';
import { apiConfig } from '@/config/api';
import { authKeys } from '@/config/keys';
import { getCookie } from '@/utils/cookies';

const getSuggestedWallet = async () => {
  const { data } = await api.get<WalletSuggestionResponse>(
    apiConfig.routes.wallet.suggested.investments
  );
  return data;
};

export const useGetSuggestedWallet = () => {
  const authToken = getCookie(authKeys.authToken);
  return useQuery({
    queryKey: ['wallet', 'suggested'],
    queryFn: getSuggestedWallet,
    enabled: !!authToken,
  });
};

type WalletSuggestionResponse = {
  categories: WalletInvestmentCategory[];
  investments_total: number;
  profile_title: InvestorProfile;
  strategies: WalletInvestmentCategory[];
  subcategories: WalletInvestmentCategory[];
};
